import {ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {CodaltComponent} from './components/codalt/codalt.component';

@Injectable()
export class CanDeactivate<T extends CodaltComponent> {

    constructor() {
    }

    canDeactivate(
        component: T,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (typeof component.handleEscape === 'function') {
            return component.handleEscape();
        }
        return true;
    }
}
